// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Container} from '../container/Container'
import {Icon} from '../icon/Icon'

// Libraries
import dayjs from 'dayjs'
import {HttpService} from "../../../services/HttpService";
import {Row} from "../row/Row";
import {Col} from "../col/Col";
import {Checkbox} from "../checkbox/Checkbox";
import {P} from "../p/P";
import {Button} from "../button/Button";
import {CookieSettings} from "./cookie_settings/CookieSettings";

@Component({
    components: {
        Container,
        Icon,
        MgsRow: Row,
        MgsCol: Col,
        MgsCheckbox: Checkbox,
        MgsButton: Button,
        MgsP: P,
        CookieSettings
    },
    mixins: [
        template,
    ]
})
export class Cookie extends Vue {

    public agreed: boolean = false

    public isHidden: boolean = false;

    @Prop({default: 300})
    public hideAnimationDuration!: number

    @Prop({default: 'en'})
    public language!: string

    get classes() {
        let result: string[] = [];
        if (this.isHidden) {
            result.push(`${this.$appPrefix}-cookie--hide`)
        }

        return result
    }

    public created () {
        if (document.cookie.indexOf('cookiePolicy=') !== -1) {
            this.agreed = true
        }
    }

    public onAgreed() {
        document.cookie = `cookiePolicy=1; expires=${dayjs().add(1, 'year').toString()}; path=/; SameSite=None; Secure`
        this.isHidden = true;

        setTimeout(() => {
            this.agreed = true
        }, this.hideAnimationDuration )
    }

    public handleFooterClick(itemName: string) {
        this.$emit('openPolicy', itemName);
    }
}